import React from 'react';

import {GenericModelViewer} from './GenericModelViewer';

export function GenericModelViewerListNode(props) {

    const {
        CustomData,
        Editable,
        FieldDef,
        Item,
        OnValidationUpdate,
        RootData,
        UpdateItem
    } = props;
    
    return <GenericModelViewer
        Model={FieldDef.model}
        Association={FieldDef.association}
        EditMode={Editable}
        RootData={RootData}
        Data={Item}
        SkipBorder={true}
        Update={(x) => {
            UpdateItem(x);
        }}
        OnValidationUpdate={(values, guid) => {
            if (OnValidationUpdate) {
                OnValidationUpdate(values, guid);
            }
        }}
        CustomData={CustomData}
    />;
}
